module.exports = __webpack_public_path__ + "img/love.5b7effa2.png";